import React, { Component } from "react";
import { Row, Col, Card, CardBody } from "reactstrap";
import { Link } from "react-router-dom";

import axios from 'axios';
import Loader from "../../../components/Loader";

// Remove this unused import
// import NationalPerformanceReport from "../Charts/PTA/NationalPerformanceReport";
import NationalNesPerformanceReport from "../Charts/PTA/NationalNesPerformanceReport";
// import ProgressGraph from "../Charts/PTA/ProgressGraph";

import "chartist/dist/scss/chartist.scss";
import { School, Apartment, Grade } from '@material-ui/icons';

import backend_url from "../../../routes/API_URL";
import swal from 'sweetalert';

const API_URL = backend_url['api_url'];

class PtaDashboard extends Component {
  constructor(props) {
	super(props);
	
	// Get school_id from session storage
	const schoolIdFromStorage = window.sessionStorage.getItem("school_id");
	console.log('PtaDashboard - school_id from storage:', schoolIdFromStorage);
	
	this.state = {
	  Sec_Data: { COUNT: 0 },
	  Prim_Data: { COUNT: 0 },
	  Schools: [],
	  Zones: { COUNT: 0 },
	  Clusters: { COUNT: 0 },
	  Constituencies: { COUNT: 0 },
	  Districts: { COUNT: 0 },
	  Divisions: { COUNT: 0 },
	  Standards: { COUNT: 0 },
	  Requirements: { COUNT: 0 },
	  Levels: { COUNT: 0 },
	  NesCategories: { COUNT: 0 },
	  school_id: schoolIdFromStorage,
	  bearer_auth: window.sessionStorage.getItem('token'),
	  loading: true,
	  error: null,
	  dataLoaded: false
	};
  }

  componentDidMount() {
	this.fetchDashboardData();
  }

  fetchDashboardData() {
	const { bearer_auth } = this.state;
	
	// Check if user is authenticated
	if (!bearer_auth) {
	  this.setState({ 
		error: 'No authentication token found. Please log in.',
		loading: false
	  });
	  return;
	}
	
	this.setState({ loading: true, error: null });
	
	// Create an array of promises with error handling
	const promises = [
	  axios.get(`${API_URL}/total_schools/primary`, { headers: { "Authorization": `Bearer ${bearer_auth}` } }).catch(err => ({ data: { data: [{ COUNT: 0 }] } })),
	  axios.get(`${API_URL}/total_schools/secondary`, { headers: { "Authorization": `Bearer ${bearer_auth}` } }).catch(err => ({ data: { data: [{ COUNT: 0 }] } })),
	  axios.get(`${API_URL}/total_zones`, { headers: { "Authorization": `Bearer ${bearer_auth}` } }).catch(err => ({ data: { data: [{ COUNT: 0 }] } })),
	  axios.get(`${API_URL}/total_clusters`, { headers: { "Authorization": `Bearer ${bearer_auth}` } }).catch(err => ({ data: { data: [{ COUNT: 0 }] } })),
	  axios.get(`${API_URL}/total_constituencies`, { headers: { "Authorization": `Bearer ${bearer_auth}` } }).catch(err => ({ data: { data: [{ COUNT: 0 }] } })),
	  axios.get(`${API_URL}/total_districts`, { headers: { "Authorization": `Bearer ${bearer_auth}` } }).catch(err => ({ data: { data: [{ COUNT: 0 }] } })),
	  axios.get(`${API_URL}/total_divisions`, { headers: { "Authorization": `Bearer ${bearer_auth}` } }).catch(err => ({ data: { data: [{ COUNT: 0 }] } })),
	  axios.get(`${API_URL}/total_nes`, { headers: { "Authorization": `Bearer ${bearer_auth}` } }).catch(err => ({ data: { data: [{ COUNT: 0 }] } })),
	  axios.get(`${API_URL}/total_nes_requirements`, { headers: { "Authorization": `Bearer ${bearer_auth}` } }).catch(err => ({ data: { data: [{ COUNT: 0 }] } })),
	  axios.get(`${API_URL}/total_nes_levels`, { headers: { "Authorization": `Bearer ${bearer_auth}` } }).catch(err => ({ data: { data: [{ COUNT: 0 }] } })),
	  axios.get(`${API_URL}/total_nes_categories`, { headers: { "Authorization": `Bearer ${bearer_auth}` } }).catch(err => ({ data: { data: [{ COUNT: 0 }] } })),
	];
	
	Promise.all(promises)
	  .then(([p_data, s_data, zone, cluster, constituency, district, division, standard, req, level, category]) => {
		
		// Helper function to safely extract data
		const extractCount = (data, defaultValue = 0) => {
		  if (data && data.data && data.data.length >= 1 && data.data[0] && data.data[0].COUNT !== undefined) {
			return data.data[0];
		  }
		  if (data && data.data && data.data.length >= 1) {
			return data.data[0];
		  }
		  if (data && data.data) {
			return data.data;
		  }
		  return { COUNT: defaultValue };
		};
		
		this.setState({
		  Prim_Data: extractCount(p_data),
		  Sec_Data: extractCount(s_data),
		  Zones: extractCount(zone),
		  Clusters: extractCount(cluster),
		  Constituencies: extractCount(constituency),
		  Districts: extractCount(district),
		  Divisions: extractCount(division),
		  Standards: extractCount(standard),
		  Requirements: extractCount(req),
		  Levels: extractCount(level),
		  NesCategories: extractCount(category),
		  loading: false,
		  dataLoaded: true,
		  error: null
		});
	  })
	  .catch(error => {
		console.error('PtaDashboard - Error loading data:', error);
		this.setState({ 
		  loading: false,
		  error: 'Failed to load dashboard data'
		});
		
		if (error.response?.status === 401) {
		  swal({
			title: "",
			text: "Your session has expired. You'll automatically be logged out within seconds.",
			icon: "error",
			timer: 2000
		  }).then(() => {
			window.sessionStorage.clear();
			window.location.href = '/login';
		  });
		}
	  });
  }

  render() {
	const { 
	  Prim_Data, Sec_Data, Zones, Clusters, 
	  school_id, loading, error 
	} = this.state;
	
	return (
	  <React.Fragment>
		<div className="container-fluid">
		  {/* Loader */}
		  <Row className="position-center">
			{loading && <Loader />}
		  </Row>
		  
		  {/* Error Display */}
		  {error && !loading && (
			<Row>
			  <Col xs={12}>
				<Card className="bg-danger text-white">
				  <CardBody>
					<center>
					  <h5>{error}</h5>
					  <Link to="/login" className="btn btn-light mt-2">Go to Login</Link>
					</center>
				  </CardBody>
				</Card>
			  </Col>
			</Row>
		  )}
		  
		  {/* Header */}
		  <Row className="align-items-center">
			<Col sm={6}>
			  <div className="page-title-box">
				<h4 className="font-size-18">PARENTS AND TEACHERS ASSOCIATION DASHBOARD</h4>
				<ol className="breadcrumb mb-0">
				  <li className="breadcrumb-item">
					<Link to="/#">Dashboard</Link>
				  </li>
				  <li className="breadcrumb-item active">School Overview</li>
				</ol>
			  </div>
			</Col>
			<Col sm="6">
			  <div className="float-right d-none d-md-block"></div>
			</Col>
		  </Row>
		  
		  {/* Statistics Section */}
		  {!error && (
			<Row>
			  <Col xs={12}>
				<Card>
				  <CardBody>
					<h6 className="card-title mb-4">NATIONAL STATISTICS</h6>
					<hr className="bg-success" />
					<Row className="text-white">
					  <Col xs={12} sm={6} md={3}>
						<Link className="text-success" to="/schools">
						  <Card className="border border-success">
							<CardBody>
							  <span className="float-left">Primary Schools</span>
							  <span className="float-right"><School fontSize="large" /></span>
							  <br />
							  <hr />
							  <center>
								<strong><h2>{Prim_Data?.COUNT || 0}</h2></strong>
							  </center>
							</CardBody>
						  </Card>
						</Link>
					  </Col>
					  
					  <Col xs={12} sm={6} md={3}>
						<Link className="text-success" to="/schools">
						  <Card className="border border-success">
							<CardBody>
							  <span className="float-left">Secondary Schools</span>
							  <span className="float-right"><School fontSize="large" /></span>
							  <br />
							  <hr />
							  <center>
								<strong><h2>{Sec_Data?.COUNT || 0}</h2></strong>
							  </center>
							</CardBody>
						  </Card>
						</Link>
					  </Col>
					  
					  <Col xs={12} sm={6} md={3}>
						<Link className="text-success" to="/zones">
						  <Card className="border border-success">
							<CardBody>
							  <span className="float-left">Zones</span>
							  <span className="float-right"><Apartment fontSize="large" /></span>
							  <br />
							  <hr />
							  <center>
								<strong><h2>{Zones?.COUNT || 0}</h2></strong>
							  </center>
							</CardBody>
						  </Card>
						</Link>
					  </Col>
					  
					  <Col xs={12} sm={6} md={3}>
						<Link className="text-success" to="/clusters">
						  <Card className="border border-success">
							<CardBody>
							  <span className="float-left">Clusters</span>
							  <span className="float-right"><Apartment fontSize="large" /></span>
							  <br />
							  <hr />
							  <center>
								<strong><h2>{Clusters?.COUNT || 0}</h2></strong>
							  </center>
							</CardBody>
						  </Card>
						</Link>
					  </Col>
					</Row>
				  </CardBody>
				</Card>
			  </Col>
			</Row>
		  )}
		  
		  {/* School Performance Report */}
		  <Row>
			<Col xs={12}>
			  <Card>
				<CardBody>
				  <h3 className="card-title mb-4 text-center">SCHOOL NES PERFORMANCE</h3>
				  <hr />
				  <NationalNesPerformanceReport school_id={school_id} />
				</CardBody>
			  </Card>
			</Col>
		  </Row>
		  
		  {/* School Progress Graph */}
		  <Row>
			<Col xs={12}>
			  <Card>
				<CardBody>
				  {/* <ProgressGraph school_id={school_id} /> */}
				</CardBody>
			  </Card>
			</Col>
		  </Row>
		</div>
	  </React.Fragment>
	);
  }
}

export default PtaDashboard;